import { useTranslations } from 'use-intl';

interface Props {
  remainingTime: number | null;
  isVisible: boolean;
}

export default function ProjectUsabilityTimeoutCountdown({
  remainingTime,
  isVisible,
}: Props) {
  const t = useTranslations('Usability');

  if (!isVisible || !remainingTime || remainingTime <= 0) {
    return null;
  }

  const seconds = Math.ceil(remainingTime / 1000);
  if (seconds > 30) {
    return null;
  }
  const displayTime = seconds.toString();
  const isCritical = seconds <= 10;

  return (
    <div
      data-test='usability-timeout-countdown'
      className='fixed top-2 left-2 z-40 max-w-[calc(100vw-2rem)] rounded-lg bg-white px-3 py-2 shadow-lg sm:max-w-none'
    >
      <div className='flex items-center gap-2'>
        <div
          data-is-critical={isCritical}
          className={`size-2 rounded-full data-[is-critical=false]:bg-yellow-500 data-[is-critical=true]:animate-pulse data-[is-critical=true]:bg-red-500`}
        />
        <div className='text-sm text-gray-500'>
          {t('timeoutCountdownPrefix')}{' '}
          <span
            data-is-critical={isCritical}
            className={`font-mono text-sm font-bold data-[is-critical=false]:text-yellow-600 data-[is-critical=true]:text-red-600`}
          >
            {displayTime} {t('timeoutCountdownUnit')}{' '}
          </span>{' '}
          {t('timeoutCountdownSuffix')}
        </div>
      </div>
    </div>
  );
}
